__turbopack_context__.v({
  "title": "sectionLayout-module-scss-module__4Dq2fq__title",
});
